// extracted by mini-css-extract-plugin
export default {"heroTitle":"X4MNe_hEUmSBze_2gUHY","left":"ZePvCCDX574EgAKwLz3A","center":"K_dNne4ZCqZB4c4fDVKx","title":"LTBD8VRxoJ6DzC1bfkoF"};